import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"

export const useSecondaryMenu = () => {
  const menu = useStaticQuery(graphql`
    query SecondaryMenuQuery {
      allDatoCmsSecondaryMenu(
        filter: { root: { eq: true }, anchor: { ne: null } }
        sort: { fields: position, order: ASC }
      ) {
        nodes {
          id
          locale
          root
          anchor
          link {
            ... on DatoCmsInternalLink {
              id
              anchor
              locale
              model {
                apiKey
              }
              link {
                ... on DatoCmsProductFamily {
                  ...ProductFamilyDetails
                  ...AllProductFamilySlugLocales
                }
                ... on DatoCmsProductCategory {
                  ...ProductCategoryPageDetails
                }
                ... on DatoCmsProduct {
                  ...ProductPageDetails
                  ...AllProductSlugLocales
                }
                ... on DatoCmsNewsPage {
                  ...NewsDetails
                }
                ... on DatoCmsReferencesPage {
                  ...ReferencesDetails
                  ...ReferencesAllSlugLocales
                }
                ... on DatoCmsPage {
                  ...PageDetails
                  ...PageTreeParent
                  ...AllSlugLocales
                }
                ... on DatoCmsArticle {
                  ...ArticleDetails
                  ...ArticleAllSlugLocales
                }
               
              }
            }
            ... on DatoCmsExternalLink {
              id
              anchor
              url
              model {
                apiKey
              }
            }
          }
          treeChildren {
            id
            locale
            root
            anchor
            position
            link {
              ... on DatoCmsInternalLink {
                id
                anchor
                locale
                model {
                  apiKey
                }
                link {
                  ... on DatoCmsProductFamily {
                    ...ProductFamilyDetails
                    ...AllProductFamilySlugLocales
                  }
                  ... on DatoCmsProductCategory {
                    ...ProductCategoryPageDetails
                  }
                  ... on DatoCmsProduct {
                    ...ProductPageDetails
                    ...AllProductSlugLocales
                  }
                  ... on DatoCmsNewsPage {
                    ...NewsDetails
                  }
                  ... on DatoCmsReferencesPage {
                    ...ReferencesDetails
                  }
                  ... on DatoCmsPage {
                    ...PageDetails
                    ...PageTreeParent
                    ...AllSlugLocales
                  }
                  ... on DatoCmsArticle {
                    ...ArticleDetails
                    ...ArticleAllSlugLocales
                  }
                 
                }
              }
              ... on DatoCmsExternalLink {
                id
                anchor
                url
                model {
                  apiKey
                }
              }
            }
            treeChildren {
              id
              locale
              root
              anchor
              position
              link {
                ... on DatoCmsInternalLink {
                  id
                  anchor
                  locale
                  model {
                    apiKey
                  }
                  link {
                    ... on DatoCmsProductFamily {
                      ...ProductFamilyDetails
                      ...AllProductFamilySlugLocales
                    }
                    ... on DatoCmsProductCategory {
                      ...ProductCategoryPageDetails
                    }
                    ... on DatoCmsProduct {
                      ...ProductPageDetails
                      ...AllProductSlugLocales
                    }
                    ... on DatoCmsNewsPage {
                      ...NewsDetails
                    }
                    ... on DatoCmsReferencesPage {
                      ...ReferencesDetails
                    }
                    ... on DatoCmsPage {
                      ...PageDetails
                      ...PageTreeParent
                      ...AllSlugLocales
                    }
                    ... on DatoCmsArticle {
                      ...ArticleDetails
                      ...ArticleAllSlugLocales
                    }
                 
                  }
                }
                ... on DatoCmsExternalLink {
                  id
                  anchor
                  url
                  model {
                    apiKey
                  }
                }
              }
            }
          }
        }
      }
      allDatoCmsProductFamily(filter: { slug: { ne: null } }) {
        nodes {
          slug
          id
          locale
          categories {
            id
            title
            slug
          }
        }
      }
      allDatoCmsProductCategory(filter: { slug: { ne: null } }) {
        nodes {
          id
          title
          products {
            id
            title
            slug
          }
        }
      }
    }
  `)

  const i18nMenu = menu

  return i18nMenu
}
